module.exports = __webpack_public_path__ + "static/assets/930323f74179aa022fd87939b3b2999c.svg";